import React, { Ref } from "react";
import {
  QualityLineProps,
  OrderProps,
  RoleProps,
  UserDataProps,
  ReportMachinistProps,
  RigProps,
} from "../interfaces/interfaces";
import { ColumnsType } from "antd/es/table";
import type { TablePaginationConfig } from "antd/es/table";
import type { FilterValue } from "antd/es/table/interface";

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}

interface Props {
  isLoading: boolean;
  tableParams: TableParams;
  dataTableSize: number;
  page: number;
  machinistReportData: ReportMachinistProps[];
  orderData: OrderProps[];
  userData: UserDataProps[];
  roleData: RoleProps[];
  orderToEdit: OrderProps | undefined;
  orderLineToEdit: QualityLineProps | undefined;
  roleToEdit: RoleProps | undefined;
  userToEdit: UserDataProps | undefined;
  rigNumbers: RigProps[];
  drillingCompanies: { text: string; value: string }[];
  selectedData: any[];
  searchQuery: string;
  userList: UserDataProps[];
  onChangeSearchQuery: (newValue: string) => void;
  handleSearch: (value: string) => void;
  fetchDataReport: ({}) => void;
  fetchOrderData: () => void;
  fetchRoleData: () => void;
  fetchUserData: () => void;
  fetchUserList: () => void;
  fetchRigNumbers: () => void;
  fetchOrderLineReport: ({
    machinist,
    startDate,
    endDate,
  }: {
    machinist: string | null;
    startDate: string | null;
    endDate: string | null;
  }) => void;
  onEditOrder: React.Dispatch<React.SetStateAction<OrderProps | undefined>>;
  onEditOrderLine: React.Dispatch<
    React.SetStateAction<QualityLineProps | undefined>
  >;
  onEditRole: React.Dispatch<React.SetStateAction<RoleProps | undefined>>;
  onEditUser: React.Dispatch<React.SetStateAction<UserDataProps | undefined>>;
  onMultipleSelect: <T>(
    data: ColumnsType<T>,
    selectedRows: React.Key[],
  ) => void;
  onExportExcel: <T>(type: "order" | "item") => void;
  handleEditOrder: (order: OrderProps) => void;
  handleCreateOrder: (order: OrderProps) => void;
  handleEditRole: (role: RoleProps) => void;
  handleCreateUser: (user: UserDataProps) => void;
  handleCreateRig: (rigName: string) => void;
  handleEditUser: (user: UserDataProps) => void;
  handleRemoveSelectedData: (endpoint: string) => void;
  handleRemoveUser: (idUser: string) => void;
}

const DataContext = React.createContext<Props>({
  isLoading: false,
  tableParams: {},
  dataTableSize: 10,
  page: 1,
  machinistReportData: [],
  orderData: [],
  userData: [],
  roleData: [],
  orderToEdit: undefined,
  orderLineToEdit: undefined,
  roleToEdit: undefined,
  userToEdit: undefined,
  selectedData: [],
  rigNumbers: [],
  drillingCompanies: [],
  searchQuery: "",
  userList: [],
  onChangeSearchQuery: () => {},
  handleSearch: () => {},
  fetchDataReport: () => {},
  fetchOrderData: () => {},
  fetchRoleData: () => {},
  fetchUserData: () => {},
  fetchUserList: () => {},
  fetchRigNumbers: () => {},
  fetchOrderLineReport: () => {},
  onEditOrder: () => {},
  onEditOrderLine: () => {},
  onEditRole: () => {},
  onEditUser: () => {},
  onMultipleSelect: () => {},
  onExportExcel: () => {},
  handleEditOrder: () => {},
  handleCreateOrder: () => {},
  handleEditRole: () => {},
  handleCreateUser: () => {},
  handleCreateRig: () => {},
  handleEditUser: () => {},
  handleRemoveSelectedData: () => {},
  handleRemoveUser: () => {},
});

export default DataContext;
